var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { REGION_CANDIDATES } from '../define/consts/solution';
import { isNullOrUndefinedOrEmpty } from './common';
// formの値から送信用パラメータへの変換
export const parseParams = (params) => {
    const { artifactsDescription, caution, description, pdfFileId, performance, period, point1, point2, point3, regionsOther, solutionMiddleClassId, solveIssue, status, subTitle, thumbnailFileId, title } = params, others = __rest(params
    // ラジオボタンの値は文字列なので数値に変換
    , ["artifactsDescription", "caution", "description", "pdfFileId", "performance", "period", "point1", "point2", "point3", "regionsOther", "solutionMiddleClassId", "solveIssue", "status", "subTitle", "thumbnailFileId", "title"]);
    // ラジオボタンの値は文字列なので数値に変換
    const rawPrice = parseInt(others.price, 10);
    const price = rawPrice ? rawPrice * 10000 : rawPrice;
    // 地域は最後の項目のみtextを有効にする
    const regions = REGION_CANDIDATES.map((candidate, index) => ({
        text: index !== REGION_CANDIDATES.length - 1 ? null : regionsOther,
        type: candidate.value,
    })).filter((_, index) => !!(others.regions || [])[index]);
    // faq
    const faq = (others.faq || []).filter(({ answer, question }) => typeof question === 'string' &&
        question.length > 0 &&
        typeof answer === 'string' &&
        answer.length > 0);
    // option
    const options = (others.options || []).filter(({ name: optionName, price: optionPrice }) => typeof optionName === 'string' &&
        optionName.length > 0 &&
        typeof optionPrice === 'string' &&
        optionPrice.length > 0);
    // subMiddleClasses, tags
    const subMiddleClasses = Object.keys(others.subMiddleClasses || []).filter((key) => others.subMiddleClasses[key] === true);
    const tags = Object.keys(others.tags || []).filter((key) => others.tags[key] === true);
    return {
        artifactsDescription,
        caution,
        description,
        faq,
        options,
        pdfFileId,
        performance,
        period,
        point: [point1, point2, point3].join('\n'),
        price,
        regions,
        solutionMiddleClassId: solutionMiddleClassId
            ? solutionMiddleClassId.value
            : null,
        solveIssue,
        status,
        subMiddleClasses,
        subTitle,
        tags,
        thumbnailFileId,
        title,
    };
};
// 編集用の初期値の作成
export const initialValuesForFormSolutionEdit = (professionalSolution, solutionMiddleClasses) => {
    const detail = professionalSolution.detail || {};
    // ポイント
    const points = (detail.point || '').split('\n');
    // プロジェクト事例の金額表記を１万円単位の文字列に変換する
    const price = (detail.price ? detail.price / 10000 : '').toString();
    const period = (!isNullOrUndefinedOrEmpty(detail.period) ? detail.period : '').toString();
    // 地域はチェックボックスなので、boolean型に変換する
    const regions = REGION_CANDIDATES.map((candidate) => !!(detail.regions || []).find((region) => region.type === candidate.value));
    // 地域その他
    const regionsOther = (detail.regions || []).find((region) => region.type === REGION_CANDIDATES[REGION_CANDIDATES.length - 1].value);
    const solutionMiddleClass = solutionMiddleClasses.find((category) => category.id === detail.solutionMiddleClassId);
    // サブカテゴリ
    const subMiddleClasses = [];
    (detail.subMiddleClasses || []).forEach((subMiddleClassId) => {
        subMiddleClasses[subMiddleClassId] = true;
    });
    // タグ
    const tags = [];
    (detail.tags || []).forEach((tagId) => {
        tags[tagId] = true;
    });
    const initialValues = Object.assign(Object.assign({}, detail), { images: [], options: detail.options, period, point1: points[0] || '', point2: points[1] || '', point3: points[2] || '', price,
        regions, regionsOther: regionsOther && regionsOther.text, solutionMiddleClassId: solutionMiddleClass
            ? {
                label: solutionMiddleClass.name,
                value: solutionMiddleClass.id,
            }
            : null, subMiddleClasses,
        tags });
    // 画面項目上、常に1つは表示されるのでoptions,faqを用意する
    if (!initialValues.options || initialValues.options.length === 0) {
        initialValues.options = [
            {
                name: '',
                price: '',
            },
        ];
    }
    if (!initialValues.faq || initialValues.faq.length === 0) {
        initialValues.faq = [
            {
                answer: '',
                question: '',
            },
        ];
    }
    return initialValues;
};
// 新規用の初期値の作成
export const initialValuesForFormSolutionAdd = (solution, solutionMiddleClasses) => initialValuesForFormSolutionEdit(solution, solutionMiddleClasses);
